

















import { computed, defineComponent } from "@vue/composition-api";
import { Announcement } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import useDarkModeController from "@/hooks/useDarkModeController";
import { $t } from "@/lib/i18nHelpers";
import { timeAgo } from "@/lib/time";

export default defineComponent({
  name: "MessageThreadAnnouncements",
  props: {
    announcement: { type: Object as () => Announcement, required: true },
    hasUnreadAnnouncement: { type: Boolean, default: false },
  },
  setup(props) {
    const { isDarkMode } = useDarkModeController();
    const preview = computed(() => {
      const doc = document.createElement("div");
      doc.innerHTML = props.announcement.text;
      return (doc.firstChild?.textContent ?? "").trim() || $t("message");
    });
    return {
      isDarkMode,
      preview,
      timeAgo,
    };
  },
});
